<template>
<div>
  <el-card>
    <div slot="header" class="clearfix">
      <span style="color: #409EFF">我的邀请码</span>
    </div>

    <el-form ref="queryForm" :model="queryForm" label-width="260px">
      <el-row :gutter="20">
        <el-col :span="20">
          <el-form-item prop="investMoney">
            <el-input type="textarea" v-model="queryForm.myqrcode" placeholder="http://ysj.taoxibao.top/login/Register?Code=EGTAQQ" readonly>
            </el-input>
            <span style="color: red">邀请好友注册成为商家，可获得订单服务费10.00%</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {queryShareCode} from "../../api/b2cbusiness/b2c_sharecode";
export default {
  name: "MyShareQrcode",
  mixins: [MixinCUD],
  data() {
    return {
      queryForm: {
        myqrcode:"http://ysj.taoxibao.top/login/Register?Code=EGTAQQ"
      },
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData(){
      queryShareCode().then(res=>{
        if (res.success){
          //this.queryForm.myqrcode = "https://api.weiquanai.com/register?sharecode="+res.data;
          this.queryForm.myqrcode = "http://sj.usmartdoc.com/register?sharecode="+res.data;
        }
      });
    }
  }
}
</script>

<style scoped>

</style>
